import styled from "styled-components/native";
import { View } from "react-native";
import { compose, space, border } from "../../../theming/styledSystem";

const StyledItemListUtils = compose(space, border);
export const StyledItemList = styled(View)(StyledItemListUtils);
